var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5085 15.7427H16.5058V5.90351L10.4976 10.1203L4.48936 5.90351V15.7427H2.48662V2.24896H3.68826L10.4976 7.02799L17.3069 2.24896H18.5085M18.5085 0H2.48662C1.3751 0 0.483887 1.00079 0.483887 2.24896V15.7427C0.483887 16.3391 0.694888 16.9112 1.07047 17.3329C1.44606 17.7547 1.95546 17.9916 2.48662 17.9916H18.5085C19.0397 17.9916 19.5491 17.7547 19.9246 17.3329C20.3002 16.9112 20.5112 16.3391 20.5112 15.7427V2.24896C20.5112 1.6525 20.3002 1.08046 19.9246 0.658704C19.5491 0.236943 19.0397 0 18.5085 0Z",
    fill: "#58B310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMail);
export default __webpack_public_path__ + "static/media/green_mail.b0f514375de6e28675ce2ec7c53828cd.svg";
export { ForwardRef as ReactComponent };